import { useMeasure } from "@uidotdev/usehooks";
import classNames from "classnames";
import { motion, useAnimate } from "framer-motion";
import React, { type ButtonHTMLAttributes, useEffect } from "react";

import Icon from "@atoms/Icon";

interface IProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  isActive?: boolean;
  isLoading?: boolean;
}

export default function Button({ children, onClick, disabled, isLoading = false }: IProps) {
  const [ref, { width }] = useMeasure();
  const [scope, animate] = useAnimate();

  useEffect(() => {
    if (width) {
      animate(
        scope.current,
        {
          // width: width + (loading.state ? 28 + (isPC ? 10.5 : 13) : 28),
          backgroundColor: "transparent",
        },
        { ease: [0.1, 0, 0.05, 1], duration: 0.2 },
      );
    }
  }, [animate, scope, width, disabled, isLoading]);

  return (
    <motion.button
      className={classNames(
        "font-fuzzy font-fuzzy-bold",
        "relative flex cursor-pointer items-center pt-1.5 pb-1 whitespace-nowrap disabled:cursor-not-allowed",
        "disabled:bg-grey bg-black text-black disabled:cursor-not-allowed",
        isLoading && "cursor-progress",
      )}
      disabled={disabled}
      initial={false}
      onClick={onClick}
      ref={scope}
      type="button"
    >
      <Icon className="absolute top-0 left-0" height="30" name="Button" width="120" />
      <div className={classNames("relative items-center", isLoading ? "w-27.5" : "w-30")} ref={ref}>
        {isLoading ? (
          <>
            Adding to Cart
            <span className="animate-typing absolute inline-block overflow-x-hidden">...</span>
          </>
        ) : (
          children
        )}
      </div>
    </motion.button>
  );
}
